import React, { useState } from 'react';

const ErrorPage = ({ errorImage, onClick, title, description}) => {


  return (
        <div className={`flex-1  pt-[67px] bg-[#F7F8F9] w-full z-50 min-h-screen`}>
            <div className="pt-16 pb-10 items-center px-[5%] md:px-[23%] flex flex-col gap-8">
                <div className="flex flex-col">
                    <img src={errorImage} alt="Error 404"/>
                    <h1 className="text-[#184A7D] font-itcbold text-center text-2xl sm:text-[38px]">
                        {title}
                    </h1>
                </div>
                <p className="text-[#474747] text-center font-itcbook text-base sm:text-[22px]">
                    {description}
                </p>
                <button 
                    onClick={onClick} 
                    className="bg-[#00FD8F] sm:w-[257px] sm:h-[76px] flex items-center justify-center p-4 rounded-[14px] font-itcdemi text-[#184A7D] text-2xl sm:text-4xl">
                    Regresar
                </button>
            </div>
        </div>
  );
};

export default ErrorPage;